export default __webpack_public_path__ + "static/media/선지자 에드 목사님 어떻게 영적계급올릴까요.c2590acd.jpg";